if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.navItems = this.querySelectorAll('.product-tabs-nav-item');
      this.panels = this.querySelectorAll('.product-tabs-panel');

      this.navItems.forEach(item => {
        item.addEventListener('click', () => this.switchTab(item.dataset.tab));
      });
    }

    switchTab(tabId) {
      this.navItems.forEach(item => {
        const isActive = item.dataset.tab === tabId;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach(panel => {
        panel.classList.toggle('active', panel.dataset.tabPanel === tabId);
      });
    }
  }
  customElements.define('product-tabs', ProductTabs);
}
